import Route from 'route-parser';

export const noneCountryBasedRoutesList: string[] = [
    '/layoutTest',
    '/about',
    '/home',
    '/privacy',
    '/qr',
    '/scan',
    '/terms',
    '/menu/eataly',
    '/menu/mercimarcel',
    '/menu/frenchfold-telokayer',
    '/menu/merci-marcel-club-street',
    '/menu/merci-marcel-orchard',
    '/menu/french-fold-orchard',
    '/menu/zaytinya',
    '/receipts',
    '/receipts/:id',
];

export const countryBasedRoutesList: string[] = [
    '/qr/:cc',
    '/qr/:cc/about',
    '/qr/:cc/privacy',
    '/qr/:cc/scan',
    '/qr/:cc/terms',
    '/qr/:cc/:slug/info',
    '/qr/:cc/:slug/menu',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/info',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/menu',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/legacy_menu',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/menu_with_payment',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/menu_without_payment',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/invoice',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/invoice/checkout',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/invoice/fail',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/invoice/success',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/invoice/pending',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/invoice/iframe',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/social',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/manual_amount',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/qsr',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/social',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/qsr/:menuId',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/qsr/preparation',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/qsr/order_details',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/embed/qsr',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/embed/qsr/social',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/embed/qsr/:menuId',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/embed/qsr/preparation',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/embed/qsr/order_details',
    '/receipt/:cc/:slug',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/loyalty/venues',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/loyalty/transactions',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/subscription',
    '/:cc/:loyaltySlug',
];

export const routesList: string[] = [...noneCountryBasedRoutesList, ...countryBasedRoutesList];

export const routesWithBackgroundList: string[] = [
    '/qr/:cc/:slug/info',
    '/qr/:cc/:slug/menu',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/info',
    '/qr/:cc/:slug/:id/:f1/:f2/:hash/menu',
];

export const routesWithAuthList: string[] = [
    '/qr/[cc]/[slug]/[id]/[f1]/[f2]/[hash]',
    '/qr/qr/[cc]/[slug]/[id]/[f1]/[f2]/[hash]/info',
    '/qr/qr/[cc]/[slug]/[id]/[f1]/[f2]/[hash]/menu',
    '/qr/[cc]/[slug]/[id]/[f1]/[f2]/[hash]/legacy_menu',
    '/qr/[cc]/[slug]/[id]/[f1]/[f2]/[hash]/menu_with_payment',
    '/qr/[cc]/[slug]/[id]/[f1]/[f2]/[hash]/menu_without_payment',
    '/qr/[cc]/[slug]/[id]/[f1]/[f2]/[hash]/invoice',
];

export default class Routes {
    public static getInstance() {
        if (!this.instance) {
            this.instance = new Routes();
        }

        return this.instance;
    }

    private static instance: Routes;

    private nonCountryBasedRoutes: Array<Route<any>> = [];

    private countryBasedRoutes: Array<Route<any>> = [];

    private routes: Array<Route<any>> = [];

    private withBackgroundRoutes: Array<Route<any>> = [];

    constructor() {
        this.nonCountryBasedRoutes = noneCountryBasedRoutesList.reverse().map((item) => new Route(item));
        this.countryBasedRoutes = countryBasedRoutesList.reverse().map((item) => new Route(item));
        this.routes = routesList.reverse().map((item) => new Route(item));
        this.withBackgroundRoutes = routesWithBackgroundList.reverse().map((item) => new Route(item));
    }

    public isNonCountryBasedUrl(url: string) {
        return this.nonCountryBasedRoutes.some((o) => o.match(url));
    }

    public isWithBackgroundUrl(url: string) {
        return this.withBackgroundRoutes.some((o) => o.match(url));
    }

    public exists(url: string) {
        return this.routes.some((o) => o.match(url));
    }

    public getVendorParams(url: string): { cc: string | undefined; slug: string | undefined } | undefined {
        // eslint-disable-next-line no-restricted-syntax
        for (const route of this.countryBasedRoutes) {
            const match = route.match(url);
            if (match) {
                return {
                    cc: match.cc,
                    slug: match.slug,
                };
            }
        }
        return undefined;
    }
}
